var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar },attrs:{"id":"wrapper"}},[(_vm.document)?_c('ReleasePopup',{attrs:{"show":_vm.showReleasePopupModal,"document":_vm.document},on:{"closeModalReleasePopup":_vm.closeModalReleasePopup}}):_vm._e(),_c('notifications'),_c('dashboard-navbar',{attrs:{"show":true}}),(_vm.load)?_c('div',{staticClass:"global-preloader",attrs:{"id":"preloader"}},[_c('div',{staticClass:"preloader-content"},[_c('img',{staticClass:"preloader-image",attrs:{"src":require("rhomtrip_assets/src/img/icons/rhomtrip-icon.gif"),"alt":"Loading..."}}),_c('div',{staticClass:"preloader-bar-container"},[_c('div',{staticClass:"preloader-bar",style:({ width: _vm.progressBarWidth + '%' })})]),_c('p',{staticClass:"preloader-text",attrs:{"data-aos":"fade"}},[_vm._v("Loading...")])])]):_vm._e(),_c('side-bar',[_c('template',{slot:"links"},[_c('img',{staticClass:"logo-icon",attrs:{"src":require("rhomtrip_assets/src/img/brand/icon-rhomtrip-150x158.png"),"alt":"RhomTrip"}}),_c('div',{staticClass:"nav-item text-center d-lg-block d-md-none"},[_c('span',{staticClass:"icon-open-close",class:{
            'close-side': _vm.verticalSidebar == false,
            'open-side': _vm.verticalSidebar == true,
          },on:{"click":function($event){return _vm.openSidebar()}}},[_c('i',{class:{
              'flaticon-menu-3 ': _vm.verticalSidebar == false,
              'flaticon-menu-2': _vm.verticalSidebar == true,
            }})])]),(_vm.hasUserAccess(_vm.userRole, [_vm.ROLES.SUPER_ADMIN, _vm.ROLES.ADMIN]))?_c('sidebar-item',{attrs:{"link":{
          name: 'Dashboards',
          icon: 'flaticon-trend',
          path: '/dashboard',
        }}}):_vm._e(),(
          _vm.hasUserAccess(_vm.userRole, [
            _vm.ROLES.SUPER_ADMIN,
            _vm.ROLES.ADMIN,
            _vm.ROLES.MANAGER,
            _vm.ROLES.USER,
            _vm.ROLES.SUPPORT,
          ])
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Reservations',
          icon: 'flaticon-calendar',
          path: '/reservations',
        }}}):_vm._e(),(
          _vm.hasUserAccess(_vm.userRole, [
            _vm.ROLES.SUPER_ADMIN,
            _vm.ROLES.ADMIN,
            _vm.ROLES.MANAGER,
            _vm.ROLES.USER,
            _vm.ROLES.SUPPORT,
          ])
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Quotes',
          icon: 'flaticon-tools-document',
          path: '/quotes',
        }}}):_vm._e(),(
          _vm.hasUserAccess(_vm.userRole, [
            _vm.ROLES.SUPER_ADMIN,
            _vm.ROLES.ADMIN,
            _vm.ROLES.MANAGER,
            _vm.ROLES.USER,
            _vm.ROLES.SUPPORT,
          ])
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Customers',
          icon: 'flaticon-employees',
          path: '/customers',
        }}}):_vm._e(),(
          _vm.hasUserAccess(_vm.userRole, [
            _vm.ROLES.SUPER_ADMIN,
            _vm.ROLES.ADMIN,
            _vm.ROLES.MANAGER,
            _vm.ROLES.USER,
            _vm.ROLES.SUPPORT,
          ])
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Partners',
          icon: 'flaticon-support',
          path: '/partners',
          badge: _vm.getBadgeForPartnersItem(_vm.badges),
        }}}):_vm._e(),(
          _vm.hasUserAccess(_vm.userRole, [
            _vm.ROLES.SUPER_ADMIN,
            _vm.ROLES.ADMIN,
            _vm.ROLES.MANAGER,
            _vm.ROLES.USER,
            _vm.ROLES.SUPPORT,
          ])
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Suppliers',
          icon: 'flaticon-businessman-1',
          path: '/suppliers',
        }}}):_vm._e(),(
          _vm.hasUserAccess(_vm.userRole, [
            _vm.ROLES.SUPER_ADMIN,
            _vm.ROLES.ADMIN,
            _vm.ROLES.MANAGER,
            _vm.ROLES.USER,
            _vm.ROLES.SUPPORT,
          ])
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Areas',
          icon: 'flaticon-radar',
          path: '/coverage-areas',
        }}}):_vm._e(),(
          _vm.hasUserAccess(_vm.userRole, [
            _vm.ROLES.SUPER_ADMIN,
            _vm.ROLES.ADMIN,
            _vm.ROLES.MANAGER,
            _vm.ROLES.USER,
            _vm.ROLES.SUPPORT,
          ])
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Vehicles',
          icon: 'flaticon-car',
          path: '/vehicles',
        }}}):_vm._e(),(
          _vm.hasUserAccess(_vm.userRole, [
            _vm.ROLES.SUPER_ADMIN,
            _vm.ROLES.ADMIN,
            _vm.ROLES.MANAGER,
            _vm.ROLES.USER,
            _vm.ROLES.SUPPORT,
          ])
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Rates',
          icon: 'flaticon-bold-list',
          path: '/rates',
        }}}):_vm._e(),(
          _vm.hasUserAccess(_vm.userRole, [
            _vm.ROLES.SUPER_ADMIN,
            _vm.ROLES.ADMIN,
            _vm.ROLES.MANAGER,
            _vm.ROLES.USER,
            _vm.ROLES.SUPPORT,
          ])
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Experiences',
          icon: 'flaticon-tools-traveling',
          path: '',
        }}},[(
            _vm.hasUserAccess(_vm.userRole, [
              _vm.ROLES.SUPER_ADMIN,
              _vm.ROLES.ADMIN,
              _vm.ROLES.MANAGER,
              _vm.ROLES.USER,
              _vm.ROLES.SUPPORT,
            ])
          )?_c('sidebar-item',{attrs:{"link":{
            name: 'In-House',
            path: '/experiences/rhomtrip',
          }}}):_vm._e(),(
            _vm.hasUserAccess(_vm.userRole, [
              _vm.ROLES.SUPER_ADMIN,
              _vm.ROLES.ADMIN,
              _vm.ROLES.MANAGER,
              _vm.ROLES.USER,
              _vm.ROLES.SUPPORT,
            ])
          )?_c('sidebar-item',{attrs:{"link":{
            name: 'Ventrata',
            path: '/experiences/ventrata',
          }}}):_vm._e()],1):_vm._e(),(_vm.hasUserAccess(_vm.userRole, [_vm.ROLES.SUPER_ADMIN, _vm.ROLES.ADMIN]))?_c('sidebar-item',{attrs:{"link":{
          name: 'Team',
          icon: 'flaticon-costumer',
          path: '/team',
        }}}):_vm._e(),(
          _vm.hasUserAccess(_vm.userRole, [
            _vm.ROLES.SUPER_ADMIN,
            _vm.ROLES.ADMIN,
            _vm.ROLES.MANAGER,
          ])
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Tools',
          icon: 'flaticon-tools-settings',
          path: '/tools',
        }}}):_vm._e()],1)],2),_c('div',{staticClass:"main-content"},[_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":80,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1),_c('globalFooter',{staticClass:"global-foot"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }